import { AlbumSummary } from "@/components/ai/AlbumSummary";
import { CheckWithAiButton } from "@/components/ai/CheckWithAiButton";
import { ErrorState } from "@/components/shared/error-state";
import { Skeleton } from "@/components/ui/skeleton";
import { useChecklist } from "@/hooks/use-checklist";
import type { ProjectDetail } from "@/schemas/photos";

/** The album's summary lives on the checklist, so only a checklist album can have one. */
function ChecklistAlbumSummary({ projectId, albumId }: { projectId: string; albumId: string }) {
  const { data, isPending, isError, refetch } = useChecklist(projectId);
  if (isPending) return <Skeleton className="h-12 w-full" />;
  if (isError) {
    return <ErrorState compact message="Could not load the AI summary" onRetry={() => refetch()} />;
  }
  return <AlbumSummary summary={data.albums.find((a) => a.albumId === albumId)?.summary} />;
}

/** On the Photos tab filtered to one album, for a PM: "Check with AI" and the album's summary. */
export function AlbumAiBar({ project, albumId }: { project: ProjectDetail; albumId: string }) {
  return (
    <div data-testid="album-ai-bar" className="space-y-2">
      <CheckWithAiButton projectId={project.id} albumId={albumId} />
      {project.checklist && <ChecklistAlbumSummary projectId={project.id} albumId={albumId} />}
    </div>
  );
}
